import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";

export default function securityReducer(state = initialState.security, action) {
    switch (action.type) {
        case types.AUTHORIZATION_INFO_LOADED: {
            return mergeDeep({}, action.body);
        }

        case types.INVALID_AANMELDCODE:
        case types.INVALID_ACCOUNT_ID: {
            return Object.assign([], state, {error: action.error});
        }

        default:
            return state;
    }
}